import Cookies from "js-cookie";
import Lottie from "lottie-react";
import { useEffect, useRef, useState, Fragment } from "react";
import { Modal } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Tabs from "react-bootstrap/Tabs";
import Tooltip from "react-bootstrap/Tooltip";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Zoom from "react-reveal/Zoom";
import { useLocation, useParams } from "react-router-dom";
import socket from "../../Socket";
import arrow2 from "../assets/arrow1.png";
import img1 from "../assets/position-trophy.png";
import { BsChevronLeft } from "react-icons/bs";
import img from "../assets/image 10.png";
import Animate from "../assets/loader.json";
import flag from "../assets/United Arab Emirates.png";
import "../Components/CSS/RaceCardCSS/racedetail.css";
import downloadIcon from "../assets/download (1).png"
import sortIcon from "../assets/sort.png"
import CastModal from "../Components/Modal/CastModal";
import VideoFrame from "../Components/Modal/VideoFrame";
import CardData from "../Components/RaceCard/Card";
import Draw from "../Components/RaceCard/Draw";
import Predictor from "../Components/RaceCard/Predictor";
import AiAnalysis from "../Components/RaceCard/AiAnalysis";
import PrintOut from "../Components/RaceCard/Printout";
import { useReactToPrint } from 'react-to-print';
import Summary from "../Components/RaceCard/Summary";
import TrackRecord1 from "../Components/RaceCard/TrackRecord";
import RaceNumbers from "../Components/Reuseable/RaceNumbers";
import { fetchDraw } from "../redux/getReducer/getDraw";
import { fetchRacePredictor } from "../redux/getReducer/getRacePrediction";
import { fetchRaceAiAnalysis } from "../redux/getReducer/getRaceAiAnalysis";
import { fetchsinglerace, STATUSES } from "../redux/getReducer/getSingleRace";
import { fetchSummary } from "../redux/getReducer/getSummarySlice";
import { fetchTrackRecord } from "../redux/getReducer/TrackRecord";
import { Button } from "react-bootstrap";
import { fetchHorseHistoryForRace } from "../redux/getReducer/getHorseHistoryForRace";
import Defaultimg from "../assets/Gif1000/Mey1200Dirt.gif";
import Defaultimg2 from "../assets/image not found.png";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import { IoMdPlay } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";
import { truncateRaceType } from "../service/stringUtils";
import { getRaceStatusColor } from "../service/raceStatusColor";


export default function RaceCardDetailNew() {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.search.slice(1) || location.state?.id;
  const cookiedata = Cookies.get("i18next");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: singlerace, status } = useSelector((state) => state.singlerace);
  const { data: RacePredictor } = useSelector((state) => state.RacePredictor);
  const { data: draw } = useSelector((state) => state.draw);
  const { data: summary } = useSelector((state) => state.summary);
  const { data: TrackRecord } = useSelector((state) => state.TrackRecord);
  const {
    data: raceAiAnalysis,
    status: aiAnalysisStatus,
    errorMessage: aiAnalysisErrorMessage,
  } = useSelector(
    (state) => state.raceAiAnalysis
  );
  const { data: ThemeSetting } = useSelector((state) => state.ThemeSetting);
  const historyByKey = useSelector((state) => state.horseHistoryForRace?.byKey || {});

  const [shows, setShows] = useState(false);
  const handleClosed = () => setShows(false);
  const handleShowed = () => setShows(true);

  const token = Cookies.get("token");
  const myRef = useRef(null);
  const componentRef = useRef();
  useEffect(() => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const [show, setShow] = useState(false);
  const [castdependency, setcastdependency] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = async (data) => {
    setmodaldata(data);
    await setShow(true);
  };

  const [showCast, setShowCast] = useState(false);
  const [modaldataCast, setmodaldataCast] = useState();
  const handleCloseCast = () => {
    setShowCast(false);
    setcastdependency(true);
  };
  const handleShowCast = async (data) => {
    setmodaldataCast(data);
    await setShowCast(true);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const toTitleCase = (str) => {
    if (!str) return "-";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    const scrollY = window.innerWidth <= 530 ? 1500 : 1000;
    window.scrollTo({ top: scrollY, behavior: "smooth" });
  }, []);

  const [activeTab, setActiveTab] = useState("Card");
  const [showSortPanel, setShowSortPanel] = useState(false);
  const [showPrintDownload, setShowPrintDownload] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  // 'idle' | 'preparing' | 'ready'
  const [printState, setPrintState] = useState('idle');

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `race-detail-${singlerace?.racedetail?.RaceNumber || 'card'}`,
    pageStyle: `
    @page {
      size: A4 landscape;
      margin: 8mm;
    }
    @media print {
      * { 
        -webkit-print-color-adjust: exact !important; 
        print-color-adjust: exact !important; 
        
        /* 1. Remove ALL heavy CSS effects */
        box-shadow: none !important; 
        text-shadow: none !important;
        transition: none !important; 
        animation: none !important; 
        border-radius: 0px !important; 
      }
      
      body { margin: 0; padding: 0; }
      ::-webkit-scrollbar { display: none !important; }

      /* ---- CRITICAL: Remove ALL heights so content flows immediately ---- */
      html, body,
      .new-race-detail-container,
      .new-race-tabs-section,
      .new-race-white-card-content,
      .new-race-info-grid,
      .tab-content,
      .tab-pane,
      .tab-pane.active,
      .RaceDetailCard,
      .new-table-scroll-wrapper,
      .new-inner-scroll-content,
      .new-card-tab-master-wrapper,
      .new-horse-list-container {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow: visible !important;
      }

      /* Force all tab panes to be visible (not just active) */
      .tab-pane {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
      }

      /* 2. Hide heavy animations */
      .TableLottie,
      .Lottie {
        display: none !important;
      }

      /* 3. Hide Bootstrap Accordion Vectors */
      .accordion-button::after {
        display: none !important;
      }

      /* 4. Fix Table Rendering Speed for PDF Viewers */
      table {
        table-layout: fixed !important;
        width: 100% !important;
        border-collapse: collapse !important;
      }

      /* Prevent page breaks from cutting tables in half */
      tr, td, th, .card {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }

      /* Reduce Silk and Number sizes for PDF */
      .new-silk-shirt-container {
        width: 80px !important;
        height: 80px !important;
      }
      .new-number-info-container {
        width: 80px !important;
        height: 80px !important;
      }
      .new-num-large-center {
        font-size: 32px !important;
      }
      .new-num-small-top, .new-num-gate-bottom {
        font-size: 11px !important;
      }

      /* RTL Fixes for PDF */
      .new-race-detail-container {
        direction: ${cookiedata?.startsWith('ar') ? 'rtl' : 'ltr'} !important;
      }
      
      ${cookiedata?.startsWith('ar') ? `
        .new-history-row > div, 
        .new-history-grid-header > div,
        .new-stat-column,
        .new-mini-stats div {
          text-align: right !important;
        }
        /* Un-flip horse face in PDF (if generator mirrors it) */
        .new-silk-img-fit {
          transform: scaleX(-1) !important;
          -webkit-transform: scaleX(-1) !important;
        }
          .new-silk-img-fit.is-placeholder{
           transform: scaleX(1) !important;
          -webkit-transform: scaleX(1) !important;
          }
      ` : ''}

      /* Compact tables and rows for PDF */
      .new-history-row {
        padding: 4px 10px !important;
        margin-top: 2px !important;
        font-size: 15px !important;
        border-radius: 4px !important;
      }
      .new-history-grid-header {
        padding: 6px 10px !important;
        font-size: 15px !important;
        border-radius: 4px !important;
      }
      .new-history-row > div, .new-history-grid-header > div {
        font-size: 15px !important;
      }
      .new-history-row > div, .new-history-grid-header > div {
        padding: 0 4px !important;
      }
      .new-middle-info-grid {
        gap: 5px !important;
        margin-top: 5px !important;
      }
      .new-grid-box {
        padding: 8px !important;
      }
      .new-horse-entry-card {
        padding: 6px !important;
        margin-bottom: 5px !important;
        page-break-inside: auto !important;
        break-inside: auto !important;
      }
      .new-contact-grid {
        margin-bottom: 2px !important;
      }
      .new-mini-stats {
        margin-top: 2px !important;
        gap: 5px !important;
      }
      .new-mini-stats div {
        padding: 4px 8px !important;
      }

      /* Fix overlap and shrinking map and sponsor images in PDF header */
      .new-race-detail-container {
        height: auto !important;
        min-height: auto !important;
      }

      /* Prevent mobile layout from breaking the print view */
      .new-race-top-header-bar {
        flex-direction: row !important;
        align-items: center !important;
      }
      .new-header-left-side {
        width: auto !important;
        justify-content: flex-start !important;
      }
      .new-race-info-grid > * {
        grid-column: auto !important;
        grid-row: auto !important;
      }
      .new-race-info-grid > .new-race-id-box-wrapper {
        grid-column: 1 !important;
        grid-row: 1 !important;
      }
      .new-race-info-grid > .rdg-title-stats {
        grid-column: 2 !important;
        grid-row: 1 !important;
      }
      .new-race-info-grid > .rdg-visuals-right {
        grid-column: 3 !important;
        grid-row: 1 / 3 !important;
      }
      .new-race-info-grid > .rdg-media {
        grid-column: 1 / 3 !important;
        grid-row: 2 !important;
      }

      .new-race-info-grid {
        grid-template-columns: 80px 1.5fr auto !important;
        gap: 15px !important;
        text-align: left !important;
      }
      .new-race-info-grid > * {
        text-align: left !important;
      }
      .rdg-title-stats {
        text-align: left !important;
      }
      .rdg-sponsor img {
        height: 70px !important;
        width: auto !important;
        max-width: 180px !important;
        object-fit: contain !important;
      }
      .rdg-trackmap img {
        height: 70px !important;
        width: auto !important;
        max-width: 220px !important;
        object-fit: contain !important;
      }
      .rdg-visuals-right {
        display: flex !important;
        flex-direction: row !important;
        gap: 15px !important;
        align-items: center !important;
        justify-content: flex-end !important;
      }
      .rdg-media {
        display: flex !important;
        align-items: center !important;
        gap: 15px !important;
      }

      /* Fix orange view prize bar blank page */
      .new-prize-bar-container {
        margin-top: 8px !important;
        border-radius: 6px !important;
        overflow: visible !important;
        height: auto !important;
        min-height: 0 !important;
      }
      .new-prize-overlay {
        background-attachment: scroll !important;
        padding: 10px 20px !important;
        height: auto !important;
        min-height: 0 !important;
      }

      /* Increase font sizes for PDF readability */
      .new-horse-main-name {
        font-size: 16px !important;
      }
      .new-jockey-link {
        text-decoration: none !important;
      }
      .new-mini-stats b {
        font-size: 11px !important;
      }
      .new-mini-stats p {
        font-size: 13px !important;
      }
       .speed-img {
        display: none !important;
        height:0!important;
    } 
     
    }
  `,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setIsPrinting(true);
        setPrintState('preparing');

        // Give React a small moment to update the DOM
        setTimeout(() => {
          if (!componentRef.current) {
            resolve();
            return;
          }

          // Step 1: Find all SVGs in the print area (excluding small icons that break on conversion)
          const svgs = Array.from(componentRef.current.querySelectorAll('svg')).filter(svg => {
            const parent = svg.closest('.race-play-icon, .new-mini-play-white, .new-star-icon, .new-back-arrow, .new-mini-play-white, .new-rating-arrow');
            return !parent;
          });
          let pendingImages = svgs.length;

          // If there are no SVGs, just open the print window immediately
          if (pendingImages === 0) {
            resolve();
            return;
          }

          // Step 2: Convert every SVG to a flat PNG image
          svgs.forEach((svg) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const svgData = new XMLSerializer().serializeToString(svg);
            const img = new Image();

            // Turn SVG code into a picture format
            img.setAttribute('src', 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData))));

            img.onload = () => {
              // Set the canvas to the same size as the SVG
              canvas.width = svg.clientWidth || 20;
              canvas.height = svg.clientHeight || 20;
              ctx.drawImage(img, 0, 0);

              // Create the final HTML Image element
              const pngImage = document.createElement('img');
              pngImage.src = canvas.toDataURL('image/png');
              pngImage.className = 'converted-svg';
              pngImage.style.width = (svg.clientWidth || 20) + 'px';
              pngImage.style.height = (svg.clientHeight || 20) + 'px';

              // Replace the heavy SVG with the light picture
              if (svg.parentNode) {
                svg.parentNode.replaceChild(pngImage, svg);
              }

              // Check if all images are done
              pendingImages--;
              if (pendingImages === 0) {
                resolve(); // All done! Open the print dialog.
              }
            };

            img.onerror = () => {
              // If an error happens on one image, skip it so the app does not freeze
              pendingImages--;
              if (pendingImages === 0) {
                resolve();
              }
            };
          });

        }, 100);
      });
    },
    onAfterPrint: () => {
      // Changing this state will force React to reload the component
      // This automatically removes the pictures and puts your real SVGs back!
      setIsPrinting(false);
      setPrintState('idle');
      setShowPrintDownload(false);
    },
  });

  // Called when "Printout" button is clicked
  const handlePrintoutToggle = () => {
    if (showPrintDownload) {
      // Already open — close it
      setShowPrintDownload(false);
      setPrintState('idle');
      return;
    }
    setShowPrintDownload(true);
    setPrintState('preparing');

    // Pre-load all images in the print area so PDF renders instantly
    const tryPreload = () => {
      const imgs = componentRef.current?.querySelectorAll('img') || [];
      let pending = 0;
      imgs.forEach(img => {
        if (!img.complete) {
          pending++;
          const onDone = () => {
            pending--;
            if (pending === 0) setPrintState('ready');
          };
          img.onload = onDone;
          img.onerror = onDone;
        }
      });
      if (pending === 0) setPrintState('ready');
    };

    // Small timeout to ensure DOM is ready
    setTimeout(tryPreload, 50);
  };

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    if (tabIndex == "Predictor") {
      dispatch(fetchRacePredictor({ id }));
      socket.emit("createRoom", id);
    } else if (tabIndex == "Draw") {
      dispatch(fetchDraw({ id }));
      socket.emit("leaveroom", id);
    } else if (tabIndex == "Summary") {
      dispatch(fetchSummary({ id }));
    } else if (tabIndex == "Track Record") {
      dispatch(fetchTrackRecord({ id }));
    } else if (tabIndex == "RAAS AI" || tabIndex == "AI Analysis") {
      dispatch(fetchRaceAiAnalysis({ id }));
    }
  };

  useEffect(() => {
    dispatch(fetchsinglerace({ id }));
    setActiveTab("Card");
  }, [dispatch, id, castdependency]);

  // Pre-fetch history for all horses so PDF has data
  useEffect(() => {
    const horses = singlerace?.racehorses?.RacehorsesData || [];
    horses.forEach((horse) => {
      const horseId = horse?.HorseModelIdData1?._id;
      if (id && horseId) {
        dispatch(fetchHorseHistoryForRace({ raceId: id, horseId }));
      }
    });
  }, [singlerace, id, dispatch]);

  if (status === STATUSES.ERROR) {
    return (
      <h2 style={{ margin: "100px", width: "50%" }}>
        Something went wrong!
      </h2>
    );
  }

  const DataDate = new Date(
    singlerace.racedetail && singlerace.racedetail.StartTime === null
      ? ""
      : singlerace.racedetail && singlerace.racedetail.StartTime
  );

  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  const formatedData = formatAMPM(DataDate);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { weekday: "long", month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatDateAr = (dateStr) => {
    const date = new Date(dateStr);
    const options = { weekday: "long", month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("ar", options);
  };

  const hexToRgba = (hex, opacity) => {
    if (!hex || !hex.startsWith("#")) return hex;
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const currentRaceId = singlerace?.racedetail?._id;
  
  let raceVideoLink = 
    singlerace?.racedetail?.VideoLink ||
    singlerace?.racedetail?.Video ||
    singlerace?.racedetail?.YoutubeLink;

  if (!raceVideoLink && singlerace?.racehorses?.RacehorsesData) {
    for (let i = 0; i < singlerace.racehorses.RacehorsesData.length; i++) {
      const h = singlerace.racehorses.RacehorsesData[i];
      const uaeCareer = h?.HorseModelIdData1?.UaeCareer;
      if (uaeCareer && Array.isArray(uaeCareer)) {
        const matchingCareer = uaeCareer.find((c) => 
          (c?.RaceID === currentRaceId || c?.RaceID?._id === currentRaceId || !c?.RaceID) && c?.VideoLink
        );
        if (matchingCareer) {
          raceVideoLink = matchingCareer.VideoLink;
          break;
        }
      }
    }
  }

  return (
    <Fragment>
      <div className="common-page-banner">
        {singlerace?.racedetail && (
          <h1>
            {cookiedata === "en"
              ? (singlerace?.racedetail?.RaceCourseData?.TrackNameEn || "-")
              : (singlerace?.racedetail?.RaceCourseData?.TrackNameAr || singlerace?.racedetail?.RaceCourseData?.TrackNameEn || "-")} {t("Race Details")}
          </h1>
        )}
      </div>

      <div className="container-fluid new-main-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Zoom>
                {status !== "loading" ? (
                  <div className="row RaceCardDetail" id="racedetail">
                    {singlerace && singlerace.racedetail !== undefined ? (
                      <div className="new-race-detail-container col-sm-12" dir={cookiedata?.startsWith('ar') ? "rtl" : "ltr"} style={{ background: 'rgb(255 255 255)', borderRadius: '10px' }} ref={componentRef}>
                        <div className="new-race-top-header-bar" style={{ background: `${ThemeSetting?.PrimaryColor || 'rgb(10 31 67)'}` }}>
                          <div className="new-header-left-side">
                            <div className="new-header-title-group" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                              <BsChevronLeft className="new-back-arrow" onClick={() => navigate(-1)} />
                              <h2 className="new-header-track-name">
                                {cookiedata === "en" ?
                                  (singlerace.racedetail.RaceCourseData?.TrackNameEn || "-") :
                                  (singlerace.racedetail.RaceCourseData?.TrackNameAr || singlerace.racedetail.RaceCourseData?.TrackNameEn || "-")
                                }
                              </h2>
                            </div>
                            <span className="new-header-date">
                              {cookiedata === "en" ? formatDate(singlerace?.racedetail?.Day) : formatDateAr(singlerace?.racedetail?.Day)}
                            </span>
                            <img src={flag} alt="" />
                          </div>
                          <div className="new-header-right-side">
                            <RaceNumbers racecoursedata={singlerace.racedetail === undefined ? "" : singlerace.racedetail} />
                          </div>
                        </div>
                        {singlerace.racedetail.RaceStatus === "Completed" ?
                          <div className="new-race-white-card-content">
                            <div className="new-race-info-grid ">
                              {/* Col 1: ID Box (spans both rows) */}
                              <div className="new-race-id-box-wrapper">
                                <div className="new-race-id-top-section" style={{
                                  backgroundColor: getRaceStatusColor(singlerace.racedetail.RaceStatus, singlerace.racedetail)
                                }}>
                                  <span className="new-race-label">{t("Race")} {singlerace.racedetail.RaceNumber}</span>
                                </div>
                                <div className="new-race-id-bottom-section" style={{
                                  backgroundColor: hexToRgba(getRaceStatusColor(singlerace.racedetail.RaceStatus, singlerace.racedetail), 0.2),
                                  color: getRaceStatusColor(singlerace.racedetail.RaceStatus, singlerace.racedetail)
                                }}>
                                  <span className="new-race-time">{formatedData.toLocaleUpperCase()}</span>
                                </div>
                              </div>

                              {/* Row 1, Col 2: Title + Stats (with Prize) */}
                              <div className="rdg-title-stats">
                                <h3 className="rdg-title">
                                  {cookiedata === "en"
                                    ? (singlerace.racedetail.RaceNameModelData?.NameEn || "-")
                                    : (singlerace.racedetail.RaceNameModelData?.NameAr || "-")
                                  }
                                  <span
                                    className="race-play-icon"
                                    onClick={() => raceVideoLink && handleShow(raceVideoLink)}
                                    style={{ cursor: raceVideoLink ? "pointer" : "default", opacity: raceVideoLink ? 1 : 0.6 }}
                                    title={raceVideoLink ? "Watch Race Replay" : "No Video Available"}
                                  >
                                    <IoMdPlay />
                                  </span>
                                </h3>
                                <div className="rdg-stats-row">
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Race Kind")}</span>
                                    <span className="rdg-stat-val">
                                      {toTitleCase(cookiedata === "en" ? singlerace.racedetail.RaceKindData?.NameEn : singlerace.racedetail.RaceKindData?.NameAr)}
                                    </span>
                                  </div>
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Race Type")}</span>
                                    <span className="rdg-stat-val red">
                                      {toTitleCase(cookiedata === "en" ? truncateRaceType(singlerace.racedetail.RaceTypeModelData?.NameEn) : singlerace.racedetail.RaceTypeModelData?.NameAr)}
                                    </span>
                                  </div>
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Horse Kind")}</span>
                                    <span className="rdg-stat-val red">
                                      {toTitleCase(cookiedata === "en" ? singlerace.racedetail.HorseKindinRaceData?.NameEn : singlerace.racedetail.HorseKindinRaceData?.NameAr)}
                                    </span>
                                  </div>
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Total Prize")}</span>
                                    <span className="rdg-stat-val rdg-blue">
                                      {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr}{' '}
                                      {(singlerace.racedetail.FirstPrice + singlerace.racedetail.SecondPrice + singlerace.racedetail.ThirdPrice + singlerace.racedetail.FourthPrice + singlerace.racedetail.FifthPrice + singlerace.racedetail.SixthPrice).toLocaleString()}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="rdg-visuals-right">
                                <div className="rdg-sponsor">
                                  {singlerace.racedetail.SponsorData ? (
                                    <a href={singlerace.racedetail.SponsorData.Url} target="_blank" rel="noreferrer">
                                      <img src={singlerace.racedetail.SponsorData.image || Defaultimg2} alt="sponsor" />
                                    </a>
                                  ) : (
                                    <img src={Defaultimg2} alt="default" />
                                  )}
                                </div>
                                <div className="rdg-trackmap">
                                  <img src={singlerace.racedetail.TrackLengthData?.RaceCourseImage || Defaultimg2} alt="track map" />
                                </div>
                              </div>

                              {/* Row 2, Col 2: Thumbnail + Time + Description + Track Length */}
                              <div className="rdg-media">
                                {singlerace.racedetail.RaceimagesData?.length > 0 ? (
                                  <img
                                    src={singlerace?.racedetail?.RaceimagesData[0]?.image}
                                    className="rdg-thumb"
                                    alt="race"
                                    onClick={() => raceVideoLink && handleShow(raceVideoLink)}
                                    style={{ cursor: raceVideoLink ? "pointer" : "default" }}
                                    title={raceVideoLink ? "Watch Race Replay" : ""}
                                  />
                                ) : (
                                  <img
                                    src={Defaultimg2}
                                    className="rdg-thumb"
                                    alt="race"
                                    onClick={() => raceVideoLink && handleShow(raceVideoLink)}
                                    style={{ cursor: raceVideoLink ? "pointer" : "default" }}
                                    title={raceVideoLink ? "Watch Race Replay" : ""}
                                  />
                                )}
                                <div className="rdg-time-desc">
                                  <h4 className="rdg-time-val">{singlerace.racedetail.RaceTimeAcheived || "01:44.72"}</h4>
                                  {/* <span className="rdg-time-label">{t("Running Time")}</span> */}
                                  <h5 className="rdg-desc-title">{t("Description")}</h5>
                                  <p className="rdg-desc-text">
                                    {cookiedata === "en" ? singlerace.racedetail.DescriptionEn : singlerace.racedetail.DescriptionAr}
                                  </p>
                                </div>
                                {/* <div className="rdg-track-len">
                                  {t("Track length")} : <b>{singlerace?.racedetail?.TrackLengthData?.TrackLength || "1600"}</b>
                                </div> */}
                              </div>

                              {/* Row 2, Col 3: Sponsor */}

                            </div>

                            {/* Trophy Prize Section */}
                            <div className="new-prize-bar-container" style={{ backgroundImage: "url('/./src/Webiste/assets/Auth/pages_bg.jpg')" }}>
                              <div className="new-prize-overlay">
                                <div className="new-podium-visual-side">
                                  <img src={img1} alt="Podium" className="new-podium-main-img" />
                                </div>
                                <div className="new-prize-items-wrapper">
                                  {[1, 2, 3, 4, 5, 6].map((pos) => {
                                    const priceKey = pos === 1 ? 'FirstPrice' : pos === 2 ? 'SecondPrice' : pos === 3 ? 'ThirdPrice' : pos === 4 ? 'FourthPrice' : pos === 5 ? 'FifthPrice' : 'SixthPrice';
                                    if (pos === 6 && singlerace.racedetail.SixthPrice === 0) return null;
                                    return (
                                      <div className="new-prize-column" key={pos}>
                                        <span className="new-prize-pos-label">
                                          {pos === 1 ? t("1st") : pos === 2 ? t("2nd") : pos === 3 ? t("3rd") : `${pos}th`}
                                        </span>
                                        <div className="new-prize-amount-value">
                                          <b>{formatNumber(singlerace.racedetail[priceKey])}</b>
                                          &nbsp;
                                          {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr}
                                        </div>
                                      </div>
                                    );
                                  })}

                                </div>
                              </div>
                            </div>
                          </div>
                          :
                          <div className="new-race-white-card-content">
                            <div className="new-race-info-grid no-image-grid">
                              {/* Col 1: ID Box (spans both rows) */}
                              <div className="new-race-id-box-wrapper">
                                <div className="new-race-id-top-section" style={{
                                  backgroundColor: getRaceStatusColor(singlerace.racedetail.RaceStatus, singlerace.racedetail)
                                }}>
                                  <span className="new-race-label">{t("Race")} {singlerace.racedetail.RaceNumber}</span>
                                </div>
                                <div className="new-race-id-bottom-section" style={{
                                  backgroundColor: hexToRgba(getRaceStatusColor(singlerace.racedetail.RaceStatus, singlerace.racedetail), 0.2),
                                  color: getRaceStatusColor(singlerace.racedetail.RaceStatus, singlerace.racedetail)
                                }}>
                                  <span className="new-race-time">{formatedData.toLocaleUpperCase()}</span>
                                </div>
                              </div>

                              {/* Row 1, Col 2: Title + Stats (with Prize) */}
                              <div className="rdg-title-stats">
                                <h3 className="rdg-title">
                                  {cookiedata === "en"
                                    ? (singlerace.racedetail.RaceNameModelData?.NameEn || "-")
                                    : (singlerace.racedetail.RaceNameModelData?.NameAr || "-")
                                  }
                                </h3>
                                <div className="rdg-stats-row">
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Race Kind")}</span>
                                    <span className="rdg-stat-val">
                                      {toTitleCase(cookiedata === "en" ? singlerace.racedetail.RaceKindData?.NameEn : singlerace.racedetail.RaceKindData?.NameAr)}
                                    </span>
                                  </div>
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Race Type")}</span>
                                    <span className="rdg-stat-val red">
                                      {toTitleCase(cookiedata === "en" ? truncateRaceType(singlerace.racedetail.RaceTypeModelData?.NameEn) : singlerace.racedetail.RaceTypeModelData?.NameAr)}
                                    </span>
                                  </div>
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Horse Kind")}</span>
                                    <span className="rdg-stat-val red">
                                      {toTitleCase(cookiedata === "en" ? singlerace.racedetail.HorseKindinRaceData?.NameEn : singlerace.racedetail.HorseKindinRaceData?.NameAr)}
                                    </span>
                                  </div>

                                </div>
                              </div>

                              <div className="rdg-visuals-right">
                                <div className="rdg-sponsor">
                                  {singlerace.racedetail.SponsorData ? (
                                    <a href={singlerace.racedetail.SponsorData.Url} target="_blank" rel="noreferrer">
                                      <img src={singlerace.racedetail.SponsorData.image || Defaultimg2} alt="sponsor" />
                                    </a>
                                  ) : (
                                    <img src={Defaultimg2} alt="default" />
                                  )}
                                </div>
                                <div className="rdg-trackmap">
                                  <img src={singlerace.racedetail.TrackLengthData?.RaceCourseImage || Defaultimg2} alt="track map" />
                                </div>
                              </div>




                              {/* Row 2, Col 2: Thumbnail + Time + Description + Track Length */}
                              <div className="rdg-media">

                                <div className="rdg-time-desc no-image">
                                  <div>
                                    <h5 className="rdg-desc-title">{t("Description")}</h5>
                                    <p className="rdg-desc-text">
                                      {cookiedata === "en" ? singlerace.racedetail.DescriptionEn : singlerace.racedetail.DescriptionAr}
                                    </p>
                                  </div>
                                  <div className="rdg-stat-item">
                                    <span className="rdg-stat-label">{t("Total Prize")}</span>
                                    <span className="rdg-stat-val rdg-blue">
                                      {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr}{' '}
                                      {(singlerace.racedetail.FirstPrice + singlerace.racedetail.SecondPrice + singlerace.racedetail.ThirdPrice + singlerace.racedetail.FourthPrice + singlerace.racedetail.FifthPrice + singlerace.racedetail.SixthPrice).toLocaleString()}
                                    </span>
                                  </div>
                                </div>

                              </div>
                              {/* <div className="rdg-track-len">
                                {t("Track length")} : <b>{singlerace?.racedetail?.TrackLengthData?.TrackLength || "1600"}</b>
                              </div> */}
                              {/* Row 2, Col 3: Track Map */}

                            </div>

                            {/* Trophy Prize Section */}
                            <div className="new-prize-bar-container" style={{ backgroundImage: "url('/./src/Webiste/assets/Auth/pages_bg.jpg')" }}>
                              <div className="new-prize-overlay">
                                <div className="new-podium-visual-side">
                                  <img src={img1} alt="Podium" className="new-podium-main-img" />
                                </div>
                                <div className="new-prize-items-wrapper">
                                  {[1, 2, 3, 4, 5, 6].map((pos) => {
                                    const priceKey = pos === 1 ? 'FirstPrice' : pos === 2 ? 'SecondPrice' : pos === 3 ? 'ThirdPrice' : pos === 4 ? 'FourthPrice' : pos === 5 ? 'FifthPrice' : 'SixthPrice';
                                    if (pos === 6 && singlerace.racedetail.SixthPrice === 0) return null;
                                    return (
                                      <div className="new-prize-column" key={pos}>
                                        <span className="new-prize-pos-label">
                                          {pos === 1 ? t("1st") : pos === 2 ? t("2nd") : pos === 3 ? t("3rd") : `${pos}th`}
                                        </span>
                                        <div className="new-prize-amount-value">
                                          <b>{formatNumber(singlerace.racedetail[priceKey])}</b>
                                          &nbsp;
                                          {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        }



                        <div className="new-race-tabs-section">
                          <Tab.Container activeKey={activeTab} onSelect={handleTabChange} defaultActiveKey="Card">
                            <div className="new-tabs-header-wrap">
                              <Nav variant="tabs" className="custom-size new-styled-tabs">
                                <Nav.Item><Nav.Link eventKey="Card">{t("Card")}</Nav.Link></Nav.Item>
                                {/* Predictor tab hidden per request */}
                                {/* {singlerace?.racedetail?.RaceStatus === "Live" && (
                                  <Nav.Item><Nav.Link eventKey="Predictor">{t("Predictor")}</Nav.Link></Nav.Item>
                                )} */}
                                <Nav.Item><Nav.Link eventKey="Draw">{t("Draw")}</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="Summary">{t("Summary")}</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="Track Record">{t("Track Record")}</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="RAAS AI">{t("RAAS AI")}</Nav.Link></Nav.Item>
                              </Nav>

                              <div className="new-tab-actions">
                                <div className="new-print-wrapper">
                                  <span className="new-print-action" onClick={handlePrintoutToggle}>
                                    {t("Printout")} <small><img src={downloadIcon} alt="Printer Icon" style={{ height: "30px", width: "36px" }} /></small>
                                  </span>
                                  {showPrintDownload && singlerace && (
                                    <div
                                      className={'new-download-pdf-btn' + (printState === 'ready' ? ' pdf-ready' : '')}
                                      style={{
                                        textDecoration: 'none',
                                        cursor: printState === 'ready' ? 'pointer' : 'default',
                                        opacity: printState === 'ready' ? 1 : 0.65,
                                        display: 'flex', alignItems: 'center', gap: '6px',
                                      }}
                                      onClick={printState === 'ready' ? handlePrint : undefined}
                                    >
                                      {printState === 'preparing' ? (
                                        <>
                                          <span style={{
                                            display: 'inline-block', width: '11px', height: '11px',
                                            border: '2px solid rgba(255,255,255,0.35)',
                                            borderTopColor: '#fff', borderRadius: '50%',
                                            animation: 'pdfSpin 0.75s linear infinite', flexShrink: 0,
                                          }} />
                                          {t('Preparing')}...
                                        </>
                                      ) : (
                                        t('Download Report PDF')
                                      )}
                                    </div>
                                  )}
                                </div>
                                <span className="new-sort-action" onClick={() => setShowSortPanel(!showSortPanel)}>
                                  {t("Sort by")} <img src={sortIcon} alt="Printer Icon" style={{ height: "36px", width: "36px" }} />
                                </span>
                              </div>
                            </div>

                            <Tab.Content>
                              <Tab.Pane eventKey="Card">{activeTab === "Card" && <CardData showSortPanel={showSortPanel} setShowSortPanel={setShowSortPanel} isPrinting={isPrinting} />}</Tab.Pane>
                              {/* {singlerace?.racedetail?.RaceStatus === "Live" && (
                                <Tab.Pane eventKey="Predictor">
                                  {activeTab === "Predictor" && <div className="RaceDetailCard new-table-scroll-wrapper"><div className="new-inner-scroll-content"><Predictor RacePredictor={RacePredictor} /></div></div>}
                                </Tab.Pane>
                              )} */}
                              <Tab.Pane eventKey="Draw">
                                {activeTab === "Draw" && <div className="custom-size RaceDetailCard new-table-scroll-wrapper"><div className="new-inner-scroll-content"><Draw draw={draw} /></div></div>}
                              </Tab.Pane>
                              <Tab.Pane eventKey="Summary">
                                {activeTab === "Summary" && <div className="custom-size RaceDetailCard new-table-scroll-wrapper"><div className="new-inner-scroll-content"><Summary summary={summary} /></div></div>}
                              </Tab.Pane>
                              <Tab.Pane eventKey="Track Record">
                                {activeTab === "Track Record" && <div className="custom-size RaceDetailCard new-table-scroll-wrapper"><div className="new-inner-scroll-content"><TrackRecord1 TrackRecord={TrackRecord} /></div></div>}
                              </Tab.Pane>
                              <Tab.Pane eventKey="RAAS AI">
                                {activeTab === "RAAS AI" && (
                                  <div className="custom-size RaceDetailCard new-table-scroll-wrapper">
                                    <div className="new-inner-scroll-content">
                                      <AiAnalysis raceAiAnalysis={raceAiAnalysis} aiStatus={aiAnalysisStatus} aiErrorMessage={aiAnalysisErrorMessage} />
                                    </div>
                                  </div>
                                )}
                              </Tab.Pane>
                            </Tab.Content>
                          </Tab.Container>
                        </div>
                      </div>
                    ) : (
                      <div className="NAclass RaceCardDetail"><Lottie animationData={Animate} className="Lottie compLottie" /></div>
                    )}
                  </div>
                ) : (
                  <h2 className="RaceCardDetail"><Lottie animationData={Animate} loop={true} className="TableLottie" /></h2>
                )}
              </Zoom>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body>
          <VideoFrame data={modaldata} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Modal show={showCast} onHide={handleCloseCast} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body>
          <CastModal data={{ modaldataCast, handleCloseCast }} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Footer />
      <CoptRight />
    </Fragment>
  );
}

